<template>
  <div>
    <main class="l-content">
      <MainCarousel :carousel="pageData.top_banner"/>
      <Description v-if="pageData"
                   :col1="pageData.description1"
                   :col2="pageData.description2"
      />
      <JoinUs/>
      <GridSection/>
      <MenuCarousel/>
    </main>
  </div>

</template>

<script>
  import MainCarousel from '../components/MainCarousel'
  import Description from '../components/Description'
  import JoinUs from '../components/JoinUs'
  import GridSection from '../components/GridSection'
  import MenuCarousel from '../components/MenuCarousel'

  export default {
    name: 'Home',
    components: {MenuCarousel, GridSection, JoinUs, Description, MainCarousel},
    data() {
      return {
        pending: false
      }
    },
    computed: {
      pageData() {
        return this.$store.state.page.pageData
      }
    }
  }
</script>

<style>

</style>
